import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'contextual-menu-accessibility',
  templateUrl: './contextual-menu-accessibility.component.html',
  styleUrls: ['./contextual-menu-accessibility.component.sass']
})
export class ContextualMenuAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
